
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.53 7.352a3.5 3.5 0 11.941-4.704M5 19.088h2.61c.34 0 .679.04 1.009.12l2.758.67c.598.147 1.222.16 1.826.043l3.05-.593a4.204 4.204 0 002.127-1.107l2.158-2.1a1.503 1.503 0 000-2.168 1.61 1.61 0 00-2.06-.143l-2.515 1.835c-.36.263-.799.405-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307c0-.704-.492-1.317-1.194-1.487l-2.385-.58A5.03 5.03 0 0010.643 12c-.965 0-2.711.799-2.711.799L5 14.025M19 5.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM1 13.6v5.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C1.76 21 2.04 21 2.6 21h.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C5 20.24 5 19.96 5 19.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C4.24 12 3.96 12 3.4 12h-.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C1 12.76 1 13.04 1 13.6z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    